import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel';
import NotificationPanel from 'modules/ui/notificationPanel/NotificationPanel';
import notificationRepo from 'app/fuse-configs/notificationRepo';
import { memo } from 'react';

function RightSideLayout2() {
	return (
		<>
			<QuickPanel />
			{process.env.REACT_APP_NOTIFICATION === 'true' ? <NotificationPanel repo={notificationRepo} /> : null}
		</>
	);
}

export default memo(RightSideLayout2);
